import {
  useOrderDocuments,
  useOrderNotes,
  useRequest,
  useServiceOrderDocumentUpload,
} from '@hooks';
import { CreateOrUpdateOrderNote, Order } from '@services';
import { useStore } from '@stores';
import { Form } from 'antd';
import { observer } from 'mobx-react';
import React, { useCallback, useEffect } from 'react';
import Presentation from './OrderNotes.presentation';

interface IProps {
  order: Order;
}

export const OrderNotes: React.FC<IProps> = observer(({ order }) => {
  const { orderStore } = useStore();
  const [form] = Form.useForm();

  const orderNotesHook = useOrderNotes(order.id);
  const orderDocumentsHook = useOrderDocuments({ orderId: order.id });
  const { uploading, handleUpload } = useServiceOrderDocumentUpload(order.id);
  const { request, loading } = useRequest(order?.requestId);

  useEffect(() => {
    form.setFieldsValue({ orderId: order.id });
  }, [order]);

  const handleDocumentDelete = useCallback(
    async (id: string) => {
      await orderStore.deleteDocument({ id });
    },
    [orderStore]
  );

  const handleCreateOrUpdateNote = useCallback(
    async (values: CreateOrUpdateOrderNote) => {
      if (values.id) {
        await orderStore.updateOrderNote(values);
      } else {
        await orderStore.createOrderNote(values);
      }
      form.setFieldsValue({ description: '', id: undefined });
    },
    [orderStore, form]
  );

  return (
    <Presentation
      form={form}
      request={request}
      uploading={uploading}
      requestLoading={loading}
      orderNotesHook={orderNotesHook}
      orderDocumentsHook={orderDocumentsHook}
      handleUpload={handleUpload}
      handleDocumentDelete={handleDocumentDelete}
      handleCreateOrUpdateNote={handleCreateOrUpdateNote}
    />
  );
});
